import Image from 'next/image'
import { SpecialLayoutObject } from '@/app/(app)/(special-layout)/special-layout-objects'
import VideoComponent from '../media/videoComponent'
import { Button, Media } from '@/payload-types'
import ButtonComponent from '../button/button'
import ShareLinkIcons from '../share-link-icons/shareLinkIcons'

interface IProps {
  data?: SpecialLayoutObject
}

export const PageDesignWrapper = ({ data }: IProps) => {
  const mediaData: Media = {
    id: `${data?.title}`,
    title: '',
    createdAt: '',
    updatedAt: '',
    url: data?.iframeSrc,
    coverImage: data?.coverImage,
  }
  let button: Button | null | string = null
  button = {
    id: 'read_report',
    name: 'read_report',
    label: 'Read Report',
    backgroundColor: 'white',
    iconType: 'ArrowRight',
    updatedAt: '',
    createdAt: '',
  }

  return (
    <div className="flex flex-col pt-6 pb-6 md:pb-14 px-5 w-[1200px]">
      <span
        className={`text-white ${
          data?.type === 'medical' ? 'sm:text-[40px]' : 'sm:text-[45px]'
        } text-[25px] font-semibold sm:leading-[67px] mb-[10px]`}
      >
        {data?.title}
      </span>
      {data?.type === 'medical' && (
        <div className="text-white font-semibold text-sm sm:text-lg pb-5 sm:pb-[34px]">
          <span>
            {`All medical personnel must treat patients impartially, regardless of religion or support
          for the State of Israel. Violating this moral code, especially given their control over
          patients' lives, makes the individuals listed here exceptionally `}
            <em>
              <u>dangerous</u>
            </em>
            .
          </span>
        </div>
      )}
      <div className="flex place-content-center">
        <div className="flex min-[1000px]:flex-row  flex-col">
          {data?.iframeType === 'Video' && (
            <VideoComponent videoData={mediaData} embeddedVideo={true} />
          )}
          {data?.iframeType === 'Image' && (
            <Image src={`${data.iframeSrc}`} alt={''} width={50} height={50} />
          )}
          <div className="flex flex-col min-[1000px]:ml-[30px] max-w-[528px] text-white mt-[10px] min-[1000px]:mt-[0px]">
            <p className="text-[20px] sm:text-[30px] font-semibold leading-[25px] sm:leading-[40px] mb-[15px]">
              {data?.sectionTitle}
            </p>
            <p className="hidden sm:block text-[16px] font-semibold leading-[24px] mb-[7px]">
              {data?.sectionText}
            </p>
            <div className="mt-auto flex flex-row items-center">
              <ButtonComponent
                buttonData={button}
                url={data?.link}
                buttonCSS={
                  'bg-opacity-25 !justify-center specialLayoutButton text-sm sm:text-base font-medium sm:font-semibold rounded-lg border border-white mr-[30px] h-[40px] sm:h-[45px] w-[130px] sm:w-[160px] hover:bg-opacity-50'
                }
              />

              <ShareLinkIcons urlToShare={data?.linkToShare} pageTitle={''} specialLayout={true} />
            </div>
          </div>
        </div>
      </div>
    </div>
  )
}

export default PageDesignWrapper
